module.exports = __webpack_public_path__ + "img/eyes.a99df9c0.png";